import {
  SeatSelectTypes,
  SeatsIOSeat,
} from "~components/reservation/constants";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { showToast } from "~lib";
import { getState } from "./../index";

export const chartObjectClicked = (seat: SeatsIOSeat) => {
  log("chartObjectClicked", seat);

  const state = getState();

  if (state.options.seatSelectType !== SeatSelectTypes.FREE_SELECT) {
    return;
  }

  if (state.chart.selectedObjects?.length >= state.options.amount && !seat) {
    showToast(
      "Exceeded ticket selection amount. Deselect a seat first",
      "error"
    );
  }
};
